import { DCUITheme } from "@iddataweb/idw-common-ui/types";
import { ButtonTypes } from "@enums/button-types";
import { DCUIThemingPrimaryButton } from "../dcui-theming-primary-button/dcui-theming-primary-button";
import { DCUIThemingSecondaryButton } from "../dcui-theming-secondary-button/dcui-theming-secondary-button";
import styles from "./dcui-theming-theme-page.less";

type DCUIThemingThemePageProps = {
    dcuiTheme: DCUITheme;
};

export const DCUIThemingThemePage = (props: DCUIThemingThemePageProps) => {
    const { dcuiTheme } = props;

    return (
        <div className={styles.dcuiThemingThemePage}>
            <div className={styles.previewContainer}>
                <span>Content Preview</span>
            </div>
            <div className={styles.buttonContainer}>
                <DCUIThemingPrimaryButton
                    generalTheme={dcuiTheme.general}
                    hideSpinner={true}
                    disabled={false}
                    className={styles.postCaptureButton}
                    type={ButtonTypes.BUTTON}
                    id={"save-capture"}
                    label={"Primary Button"}
                />
                <DCUIThemingSecondaryButton
                    generalTheme={dcuiTheme.general}
                    hideSpinner={true}
                    disabled={false}
                    className={styles.postCaptureButton}
                    type={ButtonTypes.BUTTON}
                    id={"async-continue"}
                    label={"Secondary Button"}
                />
            </div>
        </div>
    );
};